import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beUpdateAppointment';
const AT = actionType(ATAG);

const beUpdateAppointment = withOptions(({ salonId, appointmentId, data, appointmentDetails }) =>
  endpoint(H.put, 'salon/:salonId/appointment/:appointmentId/', {
    AT,
    name: ATAG,
    params: { salonId, appointmentId, data, method: H.put, appointmentDetails },
    data,
  }),
);

beUpdateAppointment.AT = AT;
beUpdateAppointment.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beUpdateAppointment;
